// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FileAttachment from '../contract/FileAttachment';

export default function fileAttachment(data: FileAttachment): FileAttachment {
    const result: FileAttachment = {
        __type: 'FileAttachment:#Exchange',
        ...data,
    };

    return result;
}
